module.exports = __webpack_public_path__ + "static/media/MagicalQuestSpanish3.391dfccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/MagicalQuestSpanish3.png
// module id = 171
// module chunks = 0